import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { IconPlus } from "@tabler/icons-react";
import "react-data-grid/lib/styles.css";
import DataGrid, { textEditor, SelectCellFormatter } from "react-data-grid";
import { useState, useEffect } from "react";
import { AddKnowColumn } from "@/components/dialog/AddKnowColumn";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import { EditKnowledge } from "@/store/actions";
import { useDispatch, useSelector } from "react-redux";

interface Column {
  key: string;
  name: string;
  resizable: boolean;
  frozen: boolean;
  width: number;
  renderEditCell: typeof textEditor; // You can replace this with a more specific type if needed
  renderCell?: (params: { row: any; tabIndex: any }) => JSX.Element; // Optional renderCell if needed
}

export default function DetailtsKnowledge() {
  const location = useLocation();
  const data = location?.state?.data.flow_data;
  const { data: editResponse, loading } = useSelector(
    (state: any) => state.editKnowReducers
  );
  const [open, setOpen] = useState(false); // Manage dialog open state
  const keys = location?.state?.data.keys;
  const dispatch = useDispatch();

  const DataWithID = (data) => {
    if (!data || data.length === 0) {
      return [{ id: 0 }];
    }
    return data.map((item, index) => {
      const { ...rest } = item; // Destructure to exclude 'key' and 'user_id'
      return {
        ...rest,
        id: index,
        flow_data: rest.flow_data,
      };
    });
  };

  const [rows, setRows] = useState(DataWithID(data) || []);
  const [isDirty, setIsDirty] = useState(true);

  const [columns, setColumns] = useState<Column[]>([
    {
      key: "id",
      name: "ID",
      resizable: true,
      frozen: true,
      width: 100,
      renderEditCell: textEditor,
    },
    {
      key: "name",
      name: "Deployed Name",
      resizable: true,
      width: 200,
      frozen: true,
      renderEditCell: textEditor,
    },
    {
      key: "flow_data",
      name: "Flow Data",
      resizable: true,
      width: 200,
      frozen: false, // Set frozen as needed
      renderEditCell: textEditor,
    },
  ]);

  // Function to add an empty row
  const addEmptyRow = () => {
    const newRow = {
      id: rows.length,
      name: "",
    };
    setRows([...rows, newRow]);
  };

  const handleRowChange = (updatedRow) => {
    setRows((prevRows) =>
      prevRows.map((row) => (row.id === updatedRow.id ? updatedRow : row))
    );
  };

  const addNewColumn = (data) => {
    const newColumn: Column = {
      key: data?.name,
      name: data?.name,
      resizable: true,
      width: 200,
      frozen: false, // Adjust based on your requirements
      renderEditCell: textEditor, // Ensure renderEditCell is provided
      ...(data.type === "Checkbox" && {
        renderCell: ({ row, tabIndex }) => {
          return (
            <SelectCellFormatter
              value={row[data.name]} // Accessing the checkbox value
              onChange={() => {
                handleRowChange({ ...row, [data.name]: !row[data.name] });
              }}
              tabIndex={tabIndex}
            />
          );
        },
      }),
    };

    setColumns([...columns, newColumn]);
    handleDialogClose();
  };

  useEffect(() => {
    if (editResponse.key) {
      setIsDirty(false);
    }
  }, [editResponse]);

  const handleDialogClose = () => {
    setOpen(false); // Close the dialog
  };

  const UpdateKnowledge = () => {
    const data = {
      key: keys,
      data: rows,
    };
    console.log(rows);
    // dispatch(EditKnowledge(data))
  };

  return (
    <div className="container mt-4">
      <h2 className="text-gray-900 text-3xl font-bold">
        {location?.state?.data?.name}
      </h2>

      <div className="flex justify-end p-2">
        {isDirty && (
          <Button variant="secondary" className="mr-2" onClick={UpdateKnowledge}>
            Save
          </Button>
        )}
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild>
            <Button variant="outline">
              <IconPlus className="mr-2" />
              <span>Add Column</span>
            </Button>
          </DialogTrigger>
          <AddKnowColumn onSubmit={addNewColumn} />
        </Dialog>
      </div>
      <DataGrid
        columns={columns}
        rows={rows}
        onRowsChange={setRows}
        style={{ backgroundColor: "white" }}
        className="grid-template-columns fill-grid rdg-light border border-gray-200 w-full h-full"
      />
      <Button
        variant="outline"
        size="sm"
        onClick={addEmptyRow}
        className="inline-flex items-center mt-4"
      >
        <IconPlus className="mr-2" />
        <span>Add Row</span>
      </Button>
    </div>
  );
}
